
import { mapState } from 'vuex';

export default {
    name: 'BusinessCoverageAreaForm',
    props: {
        business: {
            type: Object,
            default() {
                return {};
            },
        },
        form: {
            type: Object,
            required: true,
        },
        isEditForm: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState(['auth']),
        distanceUnit() {
            /* eslint-disable camelcase */
            return this.auth.user?.distance_unit || 'miles';
        },
    },
    methods: {
        addLocation(location) {
            /* eslint vue/no-mutating-props: 0 */
            // @todo fix this
            this.form.locations.$model.push(location);
        },
        async removeLocation(location) {
            this.form.locations.$model = this.form.locations.$model.filter((checkLocation) => checkLocation !== location);

            if (location.id) {
                const url = `${this.$config.endpoints.organisation}/${this.business.slug}/coveragearea/${location.id}`;
                const { message } = await this.$axios.$delete(url);
                this.$store.dispatch('setFlashMessage', { message });
            }
        },
    },
};
